<template>
    <div class="skills-container">
        <div class="skills-wrap">
            <div
                class="skill-pill"
                v-for="(skill, index) in skills"
                :key="index"
            >{{ skill }}</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "skillsDiagram",
        data() {
            return {
                skills: [
                    'JavaScript / TypeScript',
                    'PHP',
                    'HTML5 & CSS3',
                    'MySQL',
                    'Neo4j & Cypher',
                    'Linux & DevOps',
                    'Software Architecture',
                    'Mobile with Capacitor',
                    'AI & Machine Learning',
                    'Cybersecurity',
                ]
            }
        }
    }
</script>

<style scoped>
    .skills-container {
        margin-top: 48px;
        max-width: 720px;
        margin-left: auto;
        margin-right: auto;
    }

    .skills-wrap {
        display: flex;
        flex-wrap: wrap;
        gap: 14px;
        justify-content: center;
    }

    .skill-pill {
        border: 2px solid #111111;
        padding: 11px 26px;
        font-family: 'Poppins', sans-serif;
        font-size: 13px;
        font-weight: 600;
        letter-spacing: 0.05em;
        text-transform: uppercase;
        color: #111111;
        background: transparent;
        cursor: default;
        transition: background-color 0.2s ease, color 0.2s ease;
        white-space: nowrap;
    }

    .skill-pill:hover {
        background-color: #111111;
        color: #F3BB35;
    }
</style>
